import React, { useMemo } from 'react';

import { type CreateFlagArgs, useFlags } from '@atlaskit/flag';
import FailureIcon from '@atlaskit/icon/core/cross-circle';

export function useMessageFlags({
	showFlags = false,
}: {
	showFlags?: boolean;
}): FlagsConfig | undefined {
	const { showFlag } = useFlags();

	const flags: FlagsConfig = useMemo(
		() => ({
			showFailure: ({ title, description, actions }) => {
				return showFlag({
					actions,
					description,
					id: flagsIds.failure,
					isAutoDismiss: true,
					icon: <FailureIcon label="Failure" spacing="spacious" />,
					testId: flagsIds.failure,
					title,
				});
			},
		}),
		[showFlag],
	);

	return !showFlags ? undefined : flags;
}

const flagsIds = {
	failure: 'nav-error-boundary-failure-flag',
};

export type FlagsConfig = Record<string, (args: CreateFlagArgs) => void>;
